import { __assign, __extends } from "tslib";
import BSSAbstractComponent from '../../bss-abstract-component/js/bss-abstract-component.js';
import checkboxTemplate from '../template/checkbox.hbs';
import BSSInfoHintComponent from '../../bss-infohint-component/js/bss-infohint-component.js';
var checkboxTemplates = {
    defaultTemplate: checkboxTemplate,
};
var BSSCheckboxAdditionalServicesComponent = /** @class */ (function (_super) {
    __extends(BSSCheckboxAdditionalServicesComponent, _super);
    /**
     *
     * @param {String} [_entityTemplate=null] _entityTemplate entity template
     * @param {String} [containerSelector=null] containerSelector component container selector
     * @param {Object} [config=null] config configuration of component
     * @param {EventManager} [EventManager=null] instance of _EventManager
     * @param {Formatter} [Formatter=null] instance of Formatter
     * @param {Resolution} [Resolution=null] Resolution class for width breakpoint handling
     * @param {object} [toolbox=null] provides common libraries: jquery and lodash
     */
    function BSSCheckboxAdditionalServicesComponent(_entityTemplate, containerSelector, config, eventManager, formatter, resolution, toolbox) {
        if (_entityTemplate === void 0) { _entityTemplate = null; }
        if (containerSelector === void 0) { containerSelector = null; }
        if (config === void 0) { config = null; }
        if (eventManager === void 0) { eventManager = null; }
        if (formatter === void 0) { formatter = null; }
        if (resolution === void 0) { resolution = null; }
        if (toolbox === void 0) { toolbox = null; }
        var _this = _super.call(this, _entityTemplate, containerSelector, config, eventManager, formatter, resolution, checkboxTemplates, toolbox) || this;
        if (_this._config.hintText || _this._config.hintTitle) {
            config.icon = undefined;
            _this._infohint = new BSSInfoHintComponent(_entityTemplate, '.' + _this._config.componentId + '_info-hint-container', __assign({}, config), eventManager, formatter, resolution, toolbox);
        }
        return _this;
    }
    /**
     * @desc actions on checkbox input change - prevent performing abstract _onInputChange
     * @param {Event} ev event object
     * @override
     */
    BSSCheckboxAdditionalServicesComponent.prototype._onInputChange = function (ev) { };
    /**
     * @desc perform custom tagging
     * @param {String} throwEvent
     * @param {Boolean} [recalculation=false]
     * @param {jQuery|HTMLElement} target
     * @emits {throwEvent}
     * @private
     * @override
     */
    BSSCheckboxAdditionalServicesComponent.prototype._throwTaggingEvent = function (throwEvent, recalculation, target) {
        var _a, _b, _c;
        if (recalculation === void 0) { recalculation = false; }
        if (target === void 0) { target = null; }
        var productId = this._config.productId[0];
        var resultData = this._config.resultData[productId];
        var taggingName = (_a = this.getCheckboxWithSelectLabelValue(this._config)) !== null && _a !== void 0 ? _a : this._config.taggingTriggerName;
        (_c = (_b = this._toolbox.dxpTagging) === null || _b === void 0 ? void 0 : _b[this._toolbox.currentEntity.entityId]) === null || _c === void 0 ? void 0 : _c.publish(throwEvent, __assign({}, resultData), taggingName || '');
    };
    BSSCheckboxAdditionalServicesComponent.prototype.getCheckboxWithSelectLabelValue = function (config) {
        var _a, _b;
        var data = JSON.parse(config.resultData[config.productId[0]][config.resultDataSource]);
        var customValues = config.customValues;
        if (customValues) {
            data = data.map(function (item) {
                var checked = customValues.checked, description = customValues.description, value = customValues.value, component_code = customValues.component_code, label = customValues.label;
                var customLabel = label
                    .map(function (l) {
                    return item[l];
                })
                    .filter(function (l) { return l != undefined && l != ''; })[0];
                item.checked = item[checked];
                item.description = item[description];
                item.value = item[value];
                item.component_code = item[component_code];
                item.label = customLabel;
                return item;
            });
        }
        return (_b = (_a = data
            .find(function (el) { return el.label === config.taggingTriggerName; })
            .values) === null || _a === void 0 ? void 0 : _a.find(function (el) { return el.checked; })) === null || _b === void 0 ? void 0 : _b.label;
    };
    /**
     * @public method
     * @desc destroys infohint and call super method
     */
    BSSCheckboxAdditionalServicesComponent.prototype.destroy = function () {
        logger.info('CheckboxComponent: ' +
            this._config.componentId +
            ' => function : destroy');
        if (typeof this._infohint !== 'undefined') {
            this._infohint.destroy();
        }
        _super.prototype.destroy.call(this);
    };
    return BSSCheckboxAdditionalServicesComponent;
}(BSSAbstractComponent));
export default BSSCheckboxAdditionalServicesComponent;
